// assets
import { IconCalendar } from '@tabler/icons';

// ==============================|| SCHEDULE MENU ITEMS ||============================== //

const schedule = {
  id: 'schedule',
  title: 'Schedule',
  type: 'group',
  children: [
    {
      id: 'schedule',
      title: 'Jadwal Kelas',
      type: 'item',
      url: '/schedule',
      icon: IconCalendar,
      breadcrumbs: false
    }
  ]
};

export default schedule;





